<template>
    <div :class="className" :id="name">
        <svg
            v-if="name === 'circle'"
            id="circle"
            :width="width"
            :height="height"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle class="cell_icon" cx="50" cy="50" r="50" :fill="fill" />
        </svg>
        <svg
            v-if="name === 'drop'"
            id="drop"
            :width="width"
            :height="height"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                class="cell_icon"
                d="M48.9722 1H50.1197C50.5481 1.36246 51.0473 1.66989 51.3897 2.09876C58.2444 10.6857 64.6994 19.5574 70.5882 28.8256C75.32 36.274 79.7055 43.9026 82.8402 52.186C84.9231 57.6893 85.5427 63.2532 84.5099 69.0886C81.2222 87.6213 62.7868 100.685 44.0128 97.5291C32.6712 95.6314 24.0225 89.6404 18.4492 79.6492C13.6677 71.0793 12.5202 62.0634 16.0852 52.6718C18.4339 46.474 21.5457 40.6728 24.9769 35.0234C30.6132 25.7457 37.0262 16.9955 43.4716 8.26621C44.7855 6.48619 46.0383 4.66062 47.3522 2.8787C47.8418 2.21831 48.429 1.62434 48.9722 1Z"
                :fill="fill"
            />
        </svg>
        <svg
            v-if="name === 'circles'"
            id="circles"
            :width="width"
            :height="height"
            fill="none"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle class="cell_icon-circle" cx="50" cy="50" r="45" :stroke="fill" stroke-width="10" />
            <circle class="cell_icon" cx="50" cy="50" r="25" :fill="fill" />
        </svg>
        <svg
            v-if="name === 'emptySquare'"
            id="emptySquare"
            :width="width"
            :height="height"
            fill="none"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path class="cell_icon-circle" d="M5 5H95V95H5V5Z" :stroke="fill" stroke-width="10" />
        </svg>
        <svg
            v-if="name === 'rhombus'"
            id="rhombus"
            :width="width"
            :height="height"
            fill="none"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path class="cell_icon" d="M20 50L49.9997 0.000259819L79.9995 50L49.9997 99.9997L20 50Z" :fill="fill" />
        </svg>
        <svg
            v-if="name === 'smallCircle'"
            id="smallCircle"
            :width="width"
            :height="height"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle class="cell_icon" cx="50" cy="50" r="25" :fill="fill" />
        </svg>
        <svg
            v-if="name === 'square'"
            id="square"
            :width="width"
            :height="height"
            fill="none"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect class="cell_icon" width="100" height="100" :fill="fill" />
        </svg>
        <svg
            v-if="name === 'squareRhombus'"
            id="squareRhombus"
            class="cell_icon"
            :width="width"
            :height="height"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect class="cell_icon" y="50" width="70.7103" height="70.7103" transform="rotate(-45 0 50)" :fill="fill" />
        </svg>
        <svg
            v-if="name === 'star'"
            id="star"
            :width="width"
            :height="height"
            fill="none"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                class="cell_icon"
                d="M49.3908 9C50.8547 9 51.7422 9.65692 52.3425 10.8967C55.8724 18.1784 59.4408 25.4415 62.9725 32.7324C63.2562 33.3153 63.5782 33.5818 64.2388 33.6762C72.0929 34.8013 79.9415 35.9745 87.7938 37.1199C90.0629 37.4512 91.2707 38.6595 90.9486 40.5415C90.7767 41.311 90.3869 42.0131 89.8268 42.5622C84.0857 48.2876 78.3184 53.984 72.5248 59.6514C72.1131 60.0567 71.9758 60.4064 72.082 61.0115C73.48 69.124 74.8269 77.2439 76.214 85.3602C76.4317 86.6351 76.0968 87.6918 75.0556 88.4431C74.0144 89.1944 72.9127 89.1425 71.7892 88.5448C64.639 84.7341 57.487 80.927 50.3332 77.1237C49.7641 76.8202 49.3359 76.7869 48.7485 77.1015C41.6593 80.8968 34.5518 84.657 27.4535 88.4375C26.5587 88.9131 25.662 89.1944 24.6629 88.8076C24.0104 88.5751 23.4629 88.1121 23.1212 87.5038C22.7796 86.8955 22.6668 86.1828 22.8036 85.4971C24.0004 78.3419 25.2076 71.1935 26.4251 64.0518C26.5953 63.0526 26.7032 62.0385 26.9411 61.0559C27.093 60.4286 26.9301 60.0456 26.4873 59.6125C20.831 54.0611 15.2039 48.4893 9.54028 42.9582C8.46977 41.9127 7.64447 40.8246 8.15502 39.2443C8.68387 37.6085 10.0527 37.2994 11.544 37.0866C19.3085 35.9763 27.0656 34.805 34.8281 33.6873C35.454 33.5966 35.7651 33.3394 36.0341 32.7861C39.5805 25.4786 43.1598 18.1858 46.7062 10.8764C47.2991 9.65877 48.1647 9.02776 49.3908 9Z"
                :fill="fill"
            />
        </svg>
        <svg
            v-if="name === 'triangle'"
            id="triangle"
            :width="width"
            :height="height"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_907_9742)">
                <path class="cell_icon" d="M50 10L93.3013 85H6.69873L50 10Z" :fill="fill" />
            </g>
            <defs>
                <clipPath id="clip0_907_9742">
                    <rect class="cell_icon" width="100" height="100" :fill="fill" />
                </clipPath>
            </defs>
        </svg>
    </div>
</template>

<script>
    export default {
        props: {
            className: String,
            name: String,
            fill: String,
            width: String,
            height: String,
        },
    };
</script>
